export default "__VITE_ASSET__7a876841__"